import { gql } from '@apollo/client/index.js'
import { useContentful } from '@ecomm/shared-apollo'
import { useMemo } from 'react'
import { anchorSectionSchema } from './schema'

const DEFAULT_ANCHOR_SECTION_QUERY = gql`
  query	Anchor_Section_Query($id: String!, $preview: Boolean!, $locale: String!) {
    anchorSection(id: $id, locale: $locale, preview: $preview) {
      __typename
      name
      component {
        __typename
        ... on CarouselWrap {
          sys {
            id
          }
          description {
            json
          }
          itemsCollection {
            items {
              sys { id }
              headline
              internalTitle
              description {
                json
              }
              image {
                url
                description
                originalWidth: width
                originalHeight: height
              }
              mobileImage {
                url
                description
                originalWidth: width
                originalHeight: height
              }
            }
          }
        }
        ... on Section {
          body {
            json
          }
          media {
            url
            description
            originalWidth: width
            originalHeight: height
          }
          type
          theme
        }
      }
    }
  }
`

export const useAnchorSectionQuery = (
  id: string,
  QUERY = DEFAULT_ANCHOR_SECTION_QUERY
) => {
  const { data: apolloData } = useContentful(QUERY, {
    id
  })

  const anchorSectionData = useMemo(
    () => anchorSectionSchema.parse(apolloData?.['anchorSection']),
    [apolloData]
  )

  return anchorSectionData
}
